(() => {
  const main = document.querySelector('#MainContent');
  if (!main || main.dataset.template !== 'product') return;

  const form = [...main.querySelectorAll('form[action*="/cart/add"]')].find(candidate => candidate.querySelector('[name="id"]'));
  const picker = main.querySelector('.variant-picker');
  const sizeNote = main.querySelector('.text-block[class*="__size_note"]');
  if (!sizeNote) return;

  const controls = picker ? [...picker.querySelectorAll('input[type="radio"], select')] : [];
  const sizeControls = controls.filter(control => /size|taille|grandeur/i.test(control.name || ''));
  if (!form || !picker || !sizeControls.length) {
    sizeNote.hidden = true;
    sizeNote.setAttribute('aria-hidden', 'true');
    sizeNote.style.display = 'none';
    return;
  }

  sizeNote.classList.add('pt-size-note');
  sizeNote.id = 'pt-size-note';

  for (const control of sizeControls) {
    if (control.matches('input[type="radio"]')) {
      control.checked = false;
      control.closest('.variant-option__button-label')?.classList.add('pt-size-choice');
    }
  }

  let sizeConfirmed = false;
  const submitButtons = [...form.querySelectorAll('[type="submit"]')];
  const stickyButton = main.querySelector('.sticky-add-to-cart__button');
  const buttons = stickyButton ? [...submitButtons, stickyButton] : submitButtons;

  for (const button of buttons) {
    button.setAttribute('aria-describedby', 'pt-size-note');
  }

  const confirmSize = () => {
    sizeConfirmed = true;
    delete sizeNote.dataset.attention;
    sizeNote.dataset.confirmed = 'true';
  };

  for (const control of sizeControls) {
    control.addEventListener('change', confirmSize);
    control.addEventListener('click', confirmSize);
  }

  const requireSize = event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    sizeNote.dataset.attention = 'true';
    picker.querySelector('input, select')?.focus();
  };

  form.addEventListener('click', event => {
    if (sizeConfirmed || !event.target.closest('[type="submit"]')) return;
    requireSize(event);
  }, true);

  form.addEventListener('submit', event => {
    if (sizeConfirmed) return;
    requireSize(event);
  }, true);

  stickyButton?.addEventListener('click', event => {
    if (sizeConfirmed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sizeNote.dataset.attention = 'true';
    picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    picker.querySelector('input, select')?.focus();
  }, true);
})();
